export { default } from "./DoubleText"
